import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";

export default class AbstractReasoningInstruction extends Component {
    constructor(props) {
        super(props);
        this.circleClick = this.circleClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
        this.state = {
            selectedOption: -1
        };
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    optionChange(value) {
        const p = this.props;
        const disabled = p.waitingForSpeech;

        if (!disabled) {
            this.setState({ selectedOption: value });
            this.props.clearDisableNext();
        }
    }

    render() {
        const p = this.props;

        return (
            <div className="test-page-content-inner test-page-instruction test-page-abstract-reasoning-instruction" >
                <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
                <div className="practice-content">
                    {renderPractice(p, this.state, this.optionChange)}
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, optionChange) {
    return (
        <div className="practice-content-inner">
            <div className="image">
                <img alt="" src={'/images/abstract-reasoning/example.jpg'} height="220px" />
            </div>
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOption(props, state, 1, optionChange)}
                {renderOption(props, state, 2, optionChange)}
                {renderOption(props, state, 3, optionChange)}
                {renderOption(props, state, 4, optionChange)}
                {renderOption(props, state, 5, optionChange)}
                {renderOption(props, state, 6, optionChange)}
            </div>
        </div>
    );
}

function renderOption(props, state, optionValue, optionChange) {
    const key = `option${optionValue}`;
    const checked = state.selectedOption === optionValue ? "checked" : "";
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    const src = `/images/abstract-reasoning/example-${optionValue}.jpg`;

    return (
        <div key={key} onClick={() => optionChange(optionValue)} className={checked} disabled={disabled}><img alt="" src={src} /></div>
    );
}
